import React, { PureComponent } from "react";
import TwoColumnsLayout from "../../layouts/two-columns";
import IncomeStatementWidget from "../../../finance/widgets/income-statement";

class TeamReportsSection6Step4 extends PureComponent {
  get left_content() {
    return (
      <span>
        <u>Financial Impact of Your Decisions</u>
        <br />
        <br />
        Financing decisions also impact the value of your business. In later
        years (i.e. rounds), your business will be valued based on the DCF
        valuation approach.
        <br />
        takes into account the following:
        <br />
        <br />
        1. Expected Free Cash Flows
        <br />
        2. Your Cost of Capital
      </span>
    );
  }

  get right_content() {
    const { incomeStatement, current_year } = this.props;

    return (
      <IncomeStatementWidget
        incomeStatement={incomeStatement}
        current_year={current_year}
      />
    );
  }

  render() {
    return (
      <TwoColumnsLayout
        title="Financing Analysis"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection6Step4;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-6/step-4.js